import { MapPin } from "lucide-react";

export function Logo({ tone = "dark", subtitle = "GROUP" }) {
    const wordmark = tone === "light" ? "text-white" : "text-[#ED6A14]";
    const sub = tone === "light" ? "text-white/70" : "text-[#0A1F44]/70";
    return (
        <div className="flex items-center gap-2.5">
            <div className="sparkle-cluster" aria-hidden>
                <span className="b1" />
                <span className="b2" />
                <span className="b3" />
                <span className="b4" />
            </div>
            <div className="leading-none">
                <div
                    className={`font-display font-extrabold tracking-tight text-lg ${wordmark}`}
                >
                    CARGIDES
                </div>
                <div
                    className={`font-display font-semibold tracking-[0.25em] text-[10px] mt-0.5 ${sub}`}
                >
                    {subtitle}
                </div>
            </div>
        </div>
    );
}

export function SiteTag({ name, city, tone = "dark", className = "" }) {
    const base =
        tone === "light"
            ? "border-white/30 text-white"
            : "border-[#0A1F44]/20 text-[#0A1F44]";
    return (
        <span
            className={`inline-flex items-center gap-1.5 border px-2.5 py-1 text-[11px] font-semibold tracking-[0.18em] uppercase ${base} ${className}`}
            data-testid="site-tag"
        >
            <MapPin size={11} strokeWidth={2.5} />
            {name} · {city}
        </span>
    );
}
